<template>
  <footer class="app-footer">
    <div class="footer-decoration">
      <div class="deco-wave"></div>
    </div>
    <div class="footer-container">
      <!-- 主要内容区 -->
      <div class="footer-main">
        <!-- Logo 和简介 -->
        <div class="footer-brand">
          <div class="brand-logo">
            <div class="logo-icon">
              <el-icon :size="32" color="white"><Monitor /></el-icon>
            </div>
            <div class="logo-text">
              <span class="brand-name">百炼谷</span>
              <span class="brand-tagline">百炼谷</span>
            </div>
          </div>
          <p class="brand-desc">专注GESP、CSP-J/S、NOIP信息学测试分享</p>
        </div>

        <!-- 链接分组 -->
        <div class="footer-links">

        </div>
      </div>



      <!-- 底部信息 -->
      <div class="footer-bottom">
        <div class="beian-info">
          <div class="beian-item">
            <span class="beian-label">备案号：</span>
            <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">津ICP备2026004441号-1</a>
          </div>
          <div class="beian-divider"></div>
          <div class="beian-item">
            <img src="https://beian.mps.gov.cn/img/ghs.png" alt="公安备案" class="beian-icon" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=12011502000989" rel="noreferrer" target="_blank" class="beian-link">津公网安备12011502000989号</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { 
  Monitor
} from '@element-plus/icons-vue'
</script>

<style scoped lang="scss">
.app-footer {
  position: relative;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  color: #94a3b8;
  padding: 80px 0 32px;
  margin-top: auto;
}

.footer-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  overflow: hidden;

  .deco-wave {
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    height: 60px;
    background: white;
    border-radius: 0 0 50% 50%;
  }
}

.footer-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
}

// 主要内容区
.footer-main {
  display: grid;
  grid-template-columns: 1.5fr 2fr;
  gap: 80px;
  margin-bottom: 48px;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 48px;
  }
}

// 品牌区域
.footer-brand {
  .brand-logo {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;

    .logo-icon {
      width: 56px;
      height: 56px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
    }

    .logo-text {
      display: flex;
      flex-direction: column;

      .brand-name {
        font-size: 28px;
        font-weight: 800;
        color: white;
        line-height: 1.2;
      }

      .brand-tagline {
        font-size: 14px;
        color: #94a3b8;
        font-weight: 500;
      }
    }
  }

  .brand-desc {
    font-size: 15px;
    line-height: 1.8;
    color: #cbd5e1;
    margin-bottom: 24px;
    max-width: 400px;
  }

  .brand-stats {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .stat-item {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: #e2e8f0;
      font-weight: 500;
    }
  }
}

// 链接分组
.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.link-group {
  .group-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 700;
    color: white;
    margin-bottom: 20px;

    .title-icon {
      width: 32px;
      height: 32px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.icon-blue {
        background: rgba(59, 130, 246, 0.2);
        color: #60a5fa;
      }

      &.icon-green {
        background: rgba(16, 185, 129, 0.2);
        color: #34d399;
      }

      &.icon-orange {
        background: rgba(245, 158, 11, 0.2);
        color: #fbbf24;
      }
    }
  }
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 12px;
  }
}

.link-item {
  color: #94a3b8;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover {
    color: white;
    transform: translateX(4px);
  }

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #64748b;
    transition: all 0.3s ease;
  }

  &:hover::before {
    background: #60a5fa;
  }
}

// 分隔线
.footer-divider {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;

  .divider-line {
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  }

  .divider-dots {
    display: flex;
    gap: 8px;

    .dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;

      &.dot-blue { background: #60a5fa; }
      &.dot-green { background: #34d399; }
      &.dot-orange { background: #fbbf24; }
      &.dot-pink { background: #f472b6; }
    }
  }
}

// 底部信息
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
}

.copyright {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 8px;
  }

  .copyright-text {
    color: #64748b;
  }

  .copyright-divider {
    color: #475569;

    @media (max-width: 640px) {
      display: none;
    }
  }

  .copyright-slogan {
    color: #94a3b8;
    font-weight: 500;
  }
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-item {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    color: white;
  }

  &.wechat:hover {
    background: #07c160;
  }

  &.qq:hover {
    background: #12b7f5;
  }

  &.email:hover {
    background: #ea4335;
  }
}

// 备案信息样式
.beian-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 8px;
  }
}

.beian-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.beian-label {
  color: #64748b;
  font-size: 13px;
}

.beian-link {
  color: #94a3b8;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s ease;

  &:hover {
    color: white;
  }
}

.beian-icon {
  width: 16px;
  height: 16px;
}

.beian-divider {
  width: 1px;
  height: 14px;
  background: #475569;

  @media (max-width: 640px) {
    display: none;
  }
}

// ==================== 移动端适配 ====================

@media (max-width: 768px) {
  .app-footer {
    padding: 60px 0 24px;
  }

  .footer-decoration {
    height: 40px;

    .deco-wave {
      top: -20px;
      height: 40px;
    }
  }

  .footer-container {
    padding: 0 16px;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 32px;
    margin-bottom: 32px;
  }

  .footer-brand {
    .brand-logo {
      gap: 12px;
      margin-bottom: 16px;

      .logo-icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
      }

      .logo-text {
        .brand-name {
          font-size: 22px;
        }

        .brand-tagline {
          font-size: 12px;
        }
      }
    }

    .brand-desc {
      font-size: 13px;
      margin-bottom: 16px;
    }

    .brand-stats {
      gap: 8px;

      .stat-item {
        font-size: 12px;

        .el-icon {
          font-size: 16px;
        }
      }
    }
  }

  .footer-links {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .link-group {
    .group-title {
      font-size: 14px;
      margin-bottom: 12px;
      gap: 6px;

      .title-icon {
        width: 26px;
        height: 26px;
        border-radius: 8px;

        .el-icon {
          font-size: 14px;
        }
      }
    }
  }

  .link-list {
    li {
      margin-bottom: 8px;
    }
  }

  .link-item {
    font-size: 12px;

    &:hover {
      transform: none;
    }
  }

  .footer-divider {
    gap: 12px;
    margin-bottom: 24px;

    .divider-dots {
      gap: 6px;

      .dot {
        width: 6px;
        height: 6px;
      }
    }
  }

  .footer-bottom {
    flex-direction: column;
    gap: 16px;
  }

  .copyright {
    flex-direction: column;
    gap: 6px;
    font-size: 12px;
    text-align: center;

    .copyright-divider {
      display: none;
    }
  }

  .social-links {
    gap: 10px;
  }

  .social-item {
    width: 38px;
    height: 38px;
    border-radius: 10px;

    .el-icon {
      font-size: 18px;
    }

    &:hover {
      transform: none;
    }
  }
}

@media (max-width: 480px) {
  .footer-links {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 375px) {
  .app-footer {
    padding: 50px 0 20px;
  }

  .footer-links {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .link-group {
    .group-title {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      padding-bottom: 8px;
    }
  }

  .link-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;

    li {
      margin-bottom: 0;
    }
  }

  .link-item::before {
    display: none;
  }
}
</style>
